import styled from 'styled-components';

export const Text = styled.span`
  text-transform: none;
`;
